import cx from "classnames"
import * as React from "react"
import * as i18n from "tb-i18n"
const styles = require("./card.styl")

interface Props {
    image: string
    logo: string
    describe: string
    link: string
    url?: string
    style?: React.CSSProperties
}

export default class Card extends React.PureComponent<Props> {
    constructor(prop) {
        super(prop)
    }
    render() {
        const { image, logo, describe, link } = this.props
        return (
            <a
                style={ this.props.style }
                className={ cx([styles["customer-card"]]) }
                href={ link ? link : "javascript:void(0);" }
                target={ link ? "_blank" : "" }
            >
                <div
                    className="customer-card-image"
                    style={{ backgroundImage: `url(${image})` }}
                />
                <div
                    className="customer-card-logo"
                    style={{ backgroundImage: `url(${logo})` }}
                >
                    {" "}
                </div>
                <div className="customer-card-detail">{describe}</div>
                <div className="customer-card-button">
                    {i18n.get("homepage.customer.check")}
                </div>
            </a>
        )
    }
}
